export enum GROUP_TYPES {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export enum GROUP_TABS {
  POSTS = 'posts',
  USERS = 'users',
  SETTINGS = 'settings'
}

export enum GROUP_STATUS {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE'
}

export interface GROUP {
  uuid: string;
  businessUuid: string;
  userUuid: string;
  type: GROUP_TYPES;
  name: string;
  image?: string;
  about?: string;
  status?: GROUP_STATUS;
}
